import { QRCodeSVG } from 'qrcode.react';

export default function DashCard({ car, eventName, baseUrl, logoUrl }) {
  const voteUrl = `${baseUrl}/vote?car=${car.id}`;
  
  return (
    <div 
      className="dash-card bg-white p-8 mx-auto print:mx-0 print:break-after-page"
      style={{ 
        width: '11in', 
        height: '8.5in', 
        fontFamily: 'system-ui, -apple-system, sans-serif',
        backgroundColor: '#ffffff'
      }}
    >
      {/* Override global heading styles */}
      <style>{`
        .dash-card, .dash-card * {
          color: #000000 !important;
        }
        .dash-card .c4ac-pink {
          color: #E91E8C !important;
        }
      `}</style>
      
      {/* Main Horizontal Layout */}
      <div className="flex h-full">
        
        {/* Left Section - Logo, Event Name & Car Number */}
        <div className="flex flex-col justify-between pr-8" style={{ width: '42%', borderRight: '4px solid #E91E8C' }}>
          
          {/* Logo & Event Name */}
          <div className="text-center pb-4" style={{ borderBottom: '3px solid #E91E8C' }}>
            <img 
              src="/c4ac-logo.png" 
              alt="Cruise for a Cause" 
              className="mx-auto mb-3" 
              style={{ height: '100px', objectFit: 'contain' }}
            />
            <div style={{ fontSize: '24px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.05em', lineHeight: '1.3' }}>
              {eventName || 'Fall Ford Fest'}
            </div>
          </div>

          {/* Large Registration Number - Takes up most of the space */}
          <div className="flex-1 flex items-center justify-center py-6">
            <div className="text-center">
              <div style={{ fontSize: '18px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.15em', marginBottom: '12px' }}>
                CAR NUMBER
              </div>
              <div style={{ border: '6px solid #E91E8C', borderRadius: '16px', padding: '24px 56px', display: 'inline-block' }}>
                <div className="c4ac-pink" style={{ fontSize: '120px', fontWeight: '900', lineHeight: '1' }}>
                  {car.registration_number}
                </div>
              </div>
            </div>
          </div>

          {/* Footer instruction */}
          <div style={{ textAlign: 'center', fontSize: '16px', fontWeight: '600', paddingTop: '12px', borderTop: '3px solid #E91E8C' }}>
            Please display this card on your dashboard
          </div>
        </div>

        {/* Right Section - Car Details & QR */}
        <div className="flex flex-col justify-between pl-8" style={{ width: '58%' }}>
          
          {/* Car Year/Make/Model - Larger and more prominent */}
          <div style={{ border: '4px solid #E91E8C', borderRadius: '16px', padding: '28px', marginBottom: '24px', background: 'linear-gradient(135deg, #fdf2f8, #ffffff)' }}>
            <div style={{ fontSize: '44px', fontWeight: '900', textAlign: 'center', lineHeight: '1.2' }}>
              {car.year} {car.make}
            </div>
            <div style={{ fontSize: '38px', fontWeight: 'bold', textAlign: 'center', marginTop: '8px' }}>
              {car.model}
            </div>
          </div>
          
          {/* Car Details - Class and Owner */}
          <div style={{ border: '3px solid #000000', borderRadius: '12px', padding: '24px', flex: 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '2px solid #cccccc', paddingBottom: '16px', marginBottom: '16px' }}>
              <span style={{ fontWeight: 'bold', fontSize: '20px', flexShrink: 0 }}>CLASS:</span>
              <span style={{ 
                fontSize: '20px', 
                textAlign: 'right', 
                maxWidth: '70%',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                hyphens: 'auto',
                lineHeight: '1.3'
              }}>
                {car.class_name}
              </span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontWeight: 'bold', fontSize: '20px' }}>OWNER:</span>
              <span style={{ fontSize: '20px' }}>{car.owner_name}</span>
            </div>
            {car.owner_city && (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '2px solid #cccccc', paddingTop: '16px', marginTop: '16px' }}>
                <span style={{ fontWeight: 'bold', fontSize: '20px' }}>CITY:</span>
                <span style={{ fontSize: '20px' }}>{car.owner_city}</span>
              </div>
            )}
          </div>

          {/* QR Code Section */}
          <div style={{ border: '4px solid #E91E8C', borderRadius: '16px', padding: '20px', display: 'flex', alignItems: 'center', marginTop: '24px', background: 'linear-gradient(135deg, #fdf2f8, #ffffff)' }}>
            <div style={{ flex: 1, paddingRight: '20px' }}>
              <div className="c4ac-pink" style={{ fontSize: '26px', fontWeight: '900', textTransform: 'uppercase' }}>
                Vote for this car!
              </div>
              <div style={{ fontSize: '18px', marginTop: '8px' }}>
                Scan the QR code to cast your People's Choice vote
              </div>
            </div>
            <div style={{ border: '3px solid #E91E8C', padding: '10px', backgroundColor: '#ffffff', borderRadius: '12px' }}>
              <QRCodeSVG 
                value={voteUrl} 
                size={100}
                level="M"
                includeMargin={false}
                fgColor="#E91E8C"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Print-specific styles component
export function DashCardPrintStyles() {
  return (
    <style>{`
      @media print {
        body * {
          visibility: hidden;
        }
        .print-area, .print-area * {
          visibility: visible;
        }
        .print-area {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
        }
        .dash-card {
          page-break-after: always;
          margin: 0 !important;
          padding: 0.5in !important;
          box-shadow: none !important;
          border: none !important;
        }
        .no-print {
          display: none !important;
        }
        @page {
          size: 11in 8.5in landscape;
          margin: 0;
        }
      }
    `}</style>
  );
}
